import { render, staticRenderFns } from "./trigger.vue?vue&type=template&id=add84460&scoped=true"
import script from "./trigger.vue?vue&type=script&lang=js"
export * from "./trigger.vue?vue&type=script&lang=js"
import style0 from "./trigger.vue?vue&type=style&index=0&id=add84460&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add84460",
  null
  
)

export default component.exports